<div class="p-6 space-y-4">
  @if (error) {
    <div class="p-3 bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 rounded-lg text-sm text-error-700 dark:text-error-400">{{ error }}</div>
  }
  <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-4">
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Prioridad <span class="text-error-500">*</span>
      </label>
      <select formControlName="idTicketPriority"
        class="w-full px-2.5 py-1.5 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500"
        [class.border-error-500]="hasError('idTicketPriority')"
        [class.border-gray-300]="!hasError('idTicketPriority')">
        <option [ngValue]="null">— Seleccione —</option>
        @for (p of priorities; track p.id) {
          <option [ngValue]="p.id">{{ p.label }} (nivel {{ p.level }})</option>
        }
      </select>
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Primera respuesta (min) <span class="text-error-500">*</span>
      </label>
      <input type="number" formControlName="firstResponseMinutes" min="1"
        class="w-full px-2.5 py-1.5 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500"
        [class.border-error-500]="hasError('firstResponseMinutes')"
        [class.border-gray-300]="!hasError('firstResponseMinutes')" />
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Resolución (min) <span class="text-error-500">*</span>
      </label>
      <input type="number" formControlName="resolutionMinutes" min="1"
        class="w-full px-2.5 py-1.5 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500"
        [class.border-error-500]="hasError('resolutionMinutes')"
        [class.border-gray-300]="!hasError('resolutionMinutes')" />
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Tiempo de seguimiento (min) <span class="text-gray-400">(opcional)</span>
      </label>
      <input type="number" formControlName="followUpMinutes" min="1" placeholder="Sin seguimiento"
        class="w-full px-2.5 py-1.5 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500"
        [class.border-error-500]="hasError('followUpMinutes')"
        [class.border-gray-300]="!hasError('followUpMinutes')" />
      <p class="mt-1 text-xs text-gray-400">Déjelo vacío si esta prioridad no requiere seguimiento.</p>
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Umbral de alerta (%) <span class="text-gray-400">(default 25)</span>
      </label>
      <input type="number" formControlName="warningThresholdPct" min="0" max="100"
        class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
    </div>
    <div class="flex justify-end gap-2 pt-3 border-t border-gray-200 dark:border-gray-700">
      <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
      <app-button type="button" [disabled]="saving" (btnClick)="guardar()">
        @if (saving) { Guardando… } @else { {{ isEditing ? 'Actualizar' : 'Agregar' }} }
      </app-button>
    </div>
  </form>
</div>
